import React from 'react';
import { Activity } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getPerformance, createAppraisal, updateAppraisal, deleteAppraisal, getEmployeeList } from '../hrisApi';

const STATUS_OPTIONS = ['Draft', 'Open', 'Submitted', 'Completed', 'Cancelled'];
const CYCLE_OPTIONS = ['Probation Review', 'Quarterly Review', 'Mid Year Review', 'Annual Review', 'Project Review'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'reviewCycle', label: 'Cycle' },
  { key: 'reviewPeriod', label: 'Period' },
  { key: 'reviewerName', label: 'Reviewer' },
  { key: 'score', label: 'Score', render: (v) => v ? `${v}/100` : '—' },
  { key: 'dueDate', label: 'Due Date' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'reviewCycle', label: 'Review Cycle', type: 'select', required: true, options: CYCLE_OPTIONS },
  { key: 'reviewPeriod', label: 'Review Period', type: 'text', required: true, placeholder: 'e.g. 2026 Q2' },
  { key: 'reviewerName', label: 'Reviewer', type: 'text', placeholder: 'Reviewer or manager' },
  { key: 'dueDate', label: 'Due Date', type: 'date' },
  { key: 'score', label: 'Score', type: 'number', placeholder: '0-100' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Draft' },
  { key: 'remarks', label: 'Remarks', type: 'textarea', placeholder: 'Performance notes...' },
];

const Performance = () => (
  <HRISListPage
    title="Performance"
    description="Manage appraisals, review cycles, KPIs, and performance feedback"
    icon={<Activity />}
    columns={columns}
    fetchData={getPerformance}
    createData={createAppraisal}
    updateData={updateAppraisal}
    deleteData={deleteAppraisal}
    formFields={formFields}
    entityName="Appraisal"
    searchPlaceholder="Search employee, reviewer, cycle..."
  />
);

export default Performance;
